import config from '@/config';
import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { TaskQueryKey } from './queryKey';
export const useGetTaskAttachments = (taskId, taskLevel, enabled) => {
    const intl = useIntl();
    const retrieveAttachmentsForTaskIds = taskIds => api.base
        .post(`${config.appUrls.documents}/api/documents/DocumentLinks`, taskIds)
        .then(res => res.data);
    const { data, isLoading, error, refetch } = useQuery([TaskQueryKey.TaskAttachments, taskId], () => {
        // if hovered over a main task, we'll retrieve the subtask IDs and check which documents are linked to them as well
        if (taskLevel === 0) {
            return api.base
                .get(`${config.appUrls.tasks}/api/plannedtasks/ChildTaskIds/${taskId}`)
                .then(({ data: subtaskIds }) => retrieveAttachmentsForTaskIds([taskId, ...subtaskIds]), () => retrieveAttachmentsForTaskIds([taskId]));
        }
        return retrieveAttachmentsForTaskIds([taskId]);
    }, {
        enabled,
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
    return {
        data,
        error,
        isLoading,
        refetch,
    };
};
